import React from 'react';
import Layout from "../../../layouts/default";



export default function SubscriptionsPortal() {
    return (
        <Layout>
            <iframe style={{
                width: "100%",
                height: "100vh",
                border: "none",
            }} src="https://subscriptions.tryprive.com/auth?storeUrl=mantlmen.myshopify.com" />
        </Layout>
    );
}
